import React from 'react';
import './Adminsidebar.css';
import { ReactComponent as Overviewicon } from '../assets/planetsystem/overviewicon.svg'
import { ReactComponent as Plantsicon } from '../assets/planetsystem/trees.svg'
import { ReactComponent as Donateicon } from '../assets/planetsystem/donateicon.svg'
import { ReactComponent as Pricingicon } from '../assets/planetsystem/pricingicon.svg'
import { ReactComponent as Settingicon } from '../assets/planetsystem/settingicon.svg'

import { Link, useNavigate, NavLink } from 'react-router-dom';
import ENV from '../constants/env-constants';

function Adminsidebar() {
  const navigate = useNavigate();

  // Define the logout function
  const logout = async () => {
    try {
      localStorage.removeItem('adminid');
      // localStorage.removeItem('loginEmail');
      localStorage.removeItem('token');
      // Make a request to the backend logout endpoint
      const response = await fetch(`${ENV.API_URL}/api/auth/signout`, {
        method: 'POST', // or 'GET', depending on your backend
        // credentials: 'include', 
      });
      console.log(response)
      if (response.ok) {
        // If logout is successful, redirect to the home page
        navigate('/');
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };
  return (
    <aside style={{boxShadow: '1px 0px 15px 0px rgba(0,0,0,0.18)'}} id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
      <div className="app-brand demo">
        {/* <a href="index.html" className="app-brand-link"> */}
        <Link to='/dashboard/home' className="app-brand-link">
          <span className="app-brand-logo demo custombrandlogocont">
            <img className="sidebarlogo" src='/img/img/Blue_Planet_v122823.jpg'></img>
          </span>
          
          {/* <span className="app-brand-text demo menu-text fw-bold ms-2">Blue Planet</span> */}
        {/* </a> */}
        </Link>
        <a href="javascript:void(0);" className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
          <i className="bx bx-chevron-left bx-sm align-middle" />
        </a>
      </div>
      <ul className="menu-inner py-1 menu-innercustom">
        {/* Layouts */}
        
        <li className="menu-item">
          {/* <a href="javascript:void(0);" className="menu-link menu-toggle menu-linkcustom"> */}
          <NavLink className="menu-link menu-toggle menu-linkcustom" to="/admindashboard/allusers">
            {/* <i className="menu-icon tf-icons bx bx-layout" /> */}
            {/* <img src={Overviewicon} style={{fill:'red!important'}} className="menu-icon tf-icons" alt="SV" /> */}
            {/* <Overviewicon className='menu-icon tf-icons sidebar-icon' /> */}
            <div data-i18n="Layouts">Users</div>
          </NavLink>
        </li>

        <li className="menu-item">
          <NavLink className="menu-link menu-toggle menu-linkcustom" to="/admindashboard/allpayments">
              {/* <Plantsicon className='menu-icon tf-icons  sidebar-iconstroke' /> */}
              <div data-i18n="Layouts">All payments</div>
          </NavLink>
        </li>

        <li className="menu-item">
          <NavLink className="menu-link menu-toggle menu-linkcustom" to="/admindashboard/allforms">
              {/* <Plantsicon className='menu-icon tf-icons  sidebar-iconstroke' /> */}
              <div data-i18n="Layouts">All forms</div>
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink className="menu-link menu-toggle menu-linkcustom" to="/admindashboard/update-users">
              {/* <Plantsicon className='menu-icon tf-icons  sidebar-iconstroke' /> */}
              <div data-i18n="Layouts">Update Users</div>
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink className="menu-link menu-toggle menu-linkcustom" to="/admindashboard/update-donations">
              {/* <Plantsicon className='menu-icon tf-icons  sidebar-iconstroke' /> */}
              <div data-i18n="Layouts">Update Donations</div>
          </NavLink>
        </li>
        {/* <li className="menu-item">
          <Link className="menu-link menu-toggle menu-linkcustom" to="/dashboard/donate">
            <Donateicon  className='menu-icon tf-icons  sidebar-icon'/>
            <div data-i18n="Layouts">Donate</div>
          </Link>
        </li>

        <li className="menu-item">
          <Link className="menu-link menu-toggle menu-linkcustom" to="/dashboard/pricing">
            <Pricingicon  className='menu-icon tf-icons sidebar-icon'/>
            <div data-i18n="Layouts">Pricing</div>
          </Link>
        </li>

        <li className="menu-item">
          <Link className="menu-link menu-toggle menu-linkcustom" to="/dashboard/settings">
            <Settingicon className='menu-icon tf-icons sidebar-icon'/>
            <div data-i18n="Layouts">Settings</div>
          </Link>
          
        </li>
        <li className="menu-item">
            <Link className="menu-link menu-toggle menu-linkcustom" onClick={logout}>
                {/* <Plantsicon className='menu-icon tf-icons  sidebar-iconstroke' />
                <div data-i18n="Layouts">Log out</div>
            </Link>
        </li> */}
        <li className="menu-item">
            <Link className="menu-link menu-toggle menu-linkcustom" onClick={logout}>
                {/* <Plantsicon className='menu-icon tf-icons  sidebar-iconstroke' /> */}
                <div data-i18n="Layouts">Log out</div>
            </Link>
        </li>
      </ul>
    </aside>
  );
}

export default Adminsidebar;